<template>
  <div v-if="selected" class="app-select-type">
    <div
      v-if="selected"
      v-down-outside="close"
      class="b-input picker-wrap color-item"
      :class="{ open: isOpen }"
      @click="toggle"
    >
      <div class="icon" :class="selected"></div>
      <div class="name">{{ selected }}</div>
      <div class="drop-down-wrap">
        <div class="drop-down">
          <div
            v-for="type in types"
            :key="type.id"
            class="color-item select-item"
            @click="select(type)"
          >
            <div class="icon" :class="type"></div>
            <div class="name">{{ type }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downOutside } from 'app/utils/directives/down-outside';

export default {
  name: 'SelectType',

  components: {},
  directives: {
    downOutside,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: null,
      types: ['video', 'picture', 'link', 'GIF'],
    };
  },
  computed: {},

  mounted() {
    this.selected = this.value;
  },
  methods: {
    select(item) {
      this.selected = item;
      this.$emit('input', item);
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/mixins.scss';

.app-select-type {
  .color-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;

    .icon {
      width: 13px;
      height: 13px;
      background-size: 100% 100%;
      background-position: center;

      &.video {
        background-image: url('./../../assets/images/youtube.svg');
      }
      &.picture {
        background-image: url('./../../assets/images/image.svg');
      }
      &.GIF {
        background-image: url('./../../assets/images/gif.svg');
      }
      &.link {
        background-image: url('./../../assets/images/link.svg');
      }
    }
    .name {
      margin-left: 10px;
    }
  }

  .select-item {
    &:hover {
      background: #f6f6f6;
    }
  }

  .picker-wrap {
    position: relative;
    border-radius: 6px;
    padding-top: 9px;
    padding-bottom: 9px;
    .drop-down-wrap {
      display: flex;
      z-index: 10;
      position: absolute;
      overflow: hidden;
      border-left: 1px solid #d7e2fe;
      border-right: 1px solid #d7e2fe;
      border-bottom: 1px solid #d7e2fe;

      border-radius: 0 0 6px 6px;
      top: 31px;
      left: -1px;
      width: 100%;
      max-height: 0;
      background: white;
      transition: max-height 0.2s ease-out;
      padding-bottom: 4px;
    }
    .drop-down {
      width: 100%;
      overflow: auto;
      margin-top: 7px;

      @include scrollbar(4px);
    }

    &.open {
      .picker-wrap {
        border-radius: 6px 6px 0 0;
      }
      .drop-down-wrap {
        max-height: 21vh;
        z-index: 20;
      }
    }
  }
}
</style>
